import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class CacheService {
    set(key: string, data: any): void {
        localStorage.setItem(key, JSON.stringify(data));
    }

    remove(key: string): void {
        localStorage.removeItem(key);
    }

    getNone(key: string): any {
        const data = localStorage.getItem(key);
        if (!data) {
            return data;
        }
        try {
            return JSON.parse(data);
        } catch (e) {
            return data;
        }
    }

}
